import clsx from "clsx"

import formatDate from "@utils/formatDate"
import formatDuration from "@utils/formatDuration"

import { Skeleton } from "@particles/index"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"
import useJobTimelineViewStates from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewStates"

import styles from "./JobPreviewScheduleDate.module.scss"
import { JobPreviewScheduleDateProps } from "./JobPreviewScheduleDate.types"

function DateInfo({ title, value }: { title: string; value: string }) {
    return (
        <div className={styles.dateInfoWrapper}>
            <p className={styles.dateInfoLabel}>{title}</p>
            <p className={styles.dateInfoValue}>{value}</p>
        </div>
    )
}

export default function JobPreviewScheduleDate(props: JobPreviewScheduleDateProps) {
    const { startTime, duration, rescheduleRequired = false } = props
    const { isLoading } = useJobPreviewCard()
    const { todayInUserTimezone } = useJobTimelineViewStates()

    if (isLoading && (!startTime || !duration)) {
        return (
            <div className={styles.base}>
                <div className={styles.dateInfoWrapper}>
                    <Skeleton width={32} height={14} />
                    <Skeleton width={40} height={18} />
                </div>
                <div className={styles.dateInfoWrapper}>
                    <Skeleton width={32} height={14} style={{ marginBottom: 4 }} />
                    <Skeleton width={48} height={18} />
                </div>
                <div className={styles.dateInfoWrapper}>
                    <Skeleton width={48} height={14} style={{ marginBottom: 4 }} />
                    <Skeleton width={56} height={18} />
                </div>
            </div>
        )
    }

    const isCurrentYear = new Date(startTime || "").getFullYear() === new Date(todayInUserTimezone).getFullYear()

    const {
        localDateString: date,
        localTimeString: time,
        isValidDate,
    } = formatDate({
        datetime: new Date(startTime || ""),
        preferredTimezone: undefined,
        addDay: false,
        addFullDay: false,
        addYear: !isCurrentYear,
        short: true,
    })

    return (
        <div className={clsx(styles.base, { [styles.rescheduleRequired]: rescheduleRequired })}>
            <DateInfo title="Date" value={isValidDate ? date : "\u2014"} />
            <DateInfo title="Time" value={isValidDate ? time : "\u2014"} />
            <DateInfo title="Duration" value={isValidDate && duration ? String(formatDuration(duration)) : "\u2014"} />
        </div>
    )
}
